import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, onMounted } from 'vue';
import AppHeader from '@/venit/app-header/app-header.vue';
import AppSidebar from '@/venit/app-sidebar/app-sidebar.vue';
import AccountService from '@/account/account.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const accountService = inject<() => AccountService>('accountService')!;

const PUBLIC_AUTH_ROUTES = ['/account/activate', '/account/password-reset', '/password/reset/request'];

onMounted(() => {
  const isPublicAuthRoute = PUBLIC_AUTH_ROUTES.some(p => window.location.pathname.startsWith(p));
  if (!isPublicAuthRoute) {
    accountService().retrieveProfiles();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "app" }, {
    default: _withCtx(() => [
      _createVNode(AppHeader),
      _createVNode(AppSidebar),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createCommentVNode(" main content "),
          _createVNode(_component_router_view)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})